export default __webpack_public_path__ + "static/media/outline-tick.af51367a.svg";